import React from 'react';
import classNames from 'classnames';
import { history } from 'umi';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import GameImage from '@/pages/home/components/GameImage';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';

import './index.scss';

export default function CompetitorsCard(props: any) {
  const { gameData = {}, activeId, setDetailIndex, entityType } = props;
  const { entity_type: gameEntityType, name, cover, country, publisher, app_id: appId } = gameData;
  const reallyEntityType = gameEntityType || entityType;
  const emblem = (country?.split('|')[0] || 'default').toLowerCase();
  const { resetDetailFilterExtend } = useFilterExtend({});

  // 点击跳转游戏详情
  const gotoSingleGames = (appId: any) => {
    // 清除详情页继承逻辑
    resetDetailFilterExtend();
    setDetailIndex([]);
    history.push(getDetailGamePath(appId));
  };

  const getDetailGamePath = (gameId: string) => {
    return getDetailGamePathCommon({
      entityType: reallyEntityType,
      gameId,
      tab: activeId,
      subTab: '',
    });
  };

  return (
    <ARightClickToJump href={getDetailGamePath(appId)} style={{ display: 'inline' }}>
      <div
        className={`dbi-competitors-card ${`dbi-competitors-card--${reallyEntityType}`}`}
        onClick={() => {
          gotoSingleGames(appId);
        }}
      >
        <GameImage
          className={classNames({
            'dbi-competitors-card-img': reallyEntityType === 'mobile',
            'dbi-competitors-card-imgRow': reallyEntityType === 'pc',
            'dbi-competitors-card-imgDire': [PC_CONSOLE_COMBINE_ENTITY_TYPE, 'console'].includes(
              reallyEntityType,
            ),
          })}
          key={'SimilarCard'}
          src={cover}
          entityType={reallyEntityType}
        />
        <div className="dbi-competitors-card-info">
          <div className="dbi-competitors-card-title">{name}</div>
          <div className="dbi-competitors-card-flex">
            <img
              src={getCountryFlag(emblem?.toLocaleUpperCase())}
              className="national-emblem"
            ></img>
            <div className="dbi-competitors-card-text">{publisher}</div>
          </div>
        </div>
      </div>
    </ARightClickToJump>
  );
}
